export default __webpack_public_path__ + "d0f205b97d9b52fe471c3bd4cdc71788.png";